const mutinid = {
  state: {
  // 启停记录弹窗
    mutualLove: false

  },
  mutations: {
  // 选择的用户名
    add_mutualLove (state, mutualLove) {
      state.mutualLove = mutualLove
      console.log(state.mutualLove, '大妹子')
    }
  },
  actions: {
  // 选择的用户名
    addmutualLove ({ commit }, data) {
      commit('add_mutualLove', data)
    // console.log(data);
    }
  },
  getters: {
    mutualLove: state => state.mutualLove
  }
}
export default mutinid



// WEBPACK FOOTER //
// ./src/store/modules/mutualLove1.js